export const SystemActionsEnum = {
  edit: {
    key: "edit",
    icon: "mdi mdi-lead-pencil",
    color: "c-gray-primary",
    bgColor: "bg-gray",
    value: "Shared:edit",
  },
  delete: {
    key: "delete",
    icon: "mdi mdi-trash-can-outline",
    color: "c-warning",
    bgColor: "bg-warning",
    value: "Shared:delete",
  },
  download: {
    key: 'download',
    icon: 'mdi mdi-download',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:download',
  },
  view: {
    key: "view",
    icon: "mdi mdi-eye-outline",
    iconAlt: "mdi mdi-eye-off-outline",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:view",
  },
  respond: {
    key: "respond",
    icon: "mdi mdi-cached",
    iconAlt: "mdi mdi-cached",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:respond",
  },
  request: {
    key: "request",
    icon: "mdi mdi-replay",
    iconAlt: "mdi mdi-replay",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:request",
  },
  settings: {
    key: "settings",
    icon: "mdi mdi-cog",
    iconAlt: "mdi mdi-cog",
    color: "c-black",
    bgColor: "bg-primary",
    value: "Shared:settings",
  },
  viewDetails: {
    key: "view-details",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:view-details",
  },
  openDetails: {
    key: "open-details",
    icon: "mdi mdi-arrow-top-right-thin",
    iconAlt: "mdi mdi-arrow-top-right-thin",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:open-details",
  },
  withdraw: {
    key: "withdraw",
    icon: "mdi mdi-eye-off-outline",
    iconAlt: "mdi mdi-eye-off-outline",
    color: "c-white",
    bgColor: "bg-primary",
    value: "Shared:withdraw",
  },
  deselect: {
    key: "deselect",
    icon: "mdi mdi-close",
    color: "c-warning",
    bgColor: "bg-warning",
    value: "Shared:deselect",
  },
  moreInfo: {
    key: "moreInfo",
    icon: "mdi mdi-information-variant",
    color: "c-primary",
    bgColor: "bg-primary",
    value: "Shared:more-information",
  },
  allocate: {
    key: "allocate",
    icon: "mdi mdi-ticket-outline",
    color: "c-primary",
    bgColor: "bg-primary",
    value: "Shared:allocate",
  },
  reserve: {
    key: "reserve",
    icon: "mdi mdi-ticket-outline",
    color: "c-primary",
    bgColor: "bg-primary",
    value: "Shared:reserve",
  },
  reject: {
    key: "reject",
    icon: "mdi mdi-close-octagon-outline",
    color: "c-danger",
    bgColor: "bg-danger",
    value: "Shared:reject",
  },
  attachment: {
    key: 'attachment',
    icon: 'mdi mdi-paperclip',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:attachment',
  },
  approve: {
    key: 'approve',
    icon: 'mdi mdi-check-decagram-outline',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:approve',
  },
  decline: {
    key: 'decline',
    icon: 'mdi mdi-decagram-outline',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:decline',
  },
  delegate: {
    key: 'delegate',
    icon: 'mdi mdi-apple-keyboard-shift',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:delegate',
  },
  cancel: {
    key: 'cancel',
    icon: 'mdi mdi-close-octagon-outline',
    color: 'c-primary',
    bgColor: 'bg-primary',
    value: 'Shared:cancel',
  },
  modify: {
    key: "modify",
    icon: "mdi mdi-lead-pencil",
    color: "c-gray-primary",
    bgColor: "bg-gray",
    value: "Shared:modify",
  },
  bulkBudgetedRequest: {
    key: "bulk-budgeted-request",
    icon: "mdi mdi-cash-multiple",
    color: "c-primary",
    bgColor: "bg-primary",
    value: "Shared:bulk-budgeted-request",
  },
};
